var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3025",
    "data-name": "\\uC0AC\\uAC01\\uD615 3025",
    width: 16,
    height: 16,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11348",
    "data-name": "\\uD328\\uC2A4 11348",
    d: "M8.492,20.494l1.6-4.936,1.539,5.58q-.228.018-.458.018a5.738,5.738,0,0,1-2.685-.662m-1.4-1.036a5.806,5.806,0,0,1-.788-.993l2.969-3.114-.909,5.067a5.785,5.785,0,0,1-1.272-.96M5.437,16l3.184-1.2L6.158,18.219A5.8,5.8,0,0,1,5.437,16m.175-2.215,2.659.242L5.408,15.582a5.85,5.85,0,0,1,.2-1.794m-4.183,4.82c0,.024-.006.048-.009.072a5.915,5.915,0,0,0-.044.7,5.806,5.806,0,0,0,5.086,5.773l.1.012a5.778,5.778,0,0,0,6.181-4.223,5.794,5.794,0,0,1-1.048.191l-.77-5.748,1.626,1.865q-.093-.234-.2-.459l0,0-.009-.019,0-.005-.015-.031-.006-.012-.007-.013-.009-.018-.006-.012-.011-.022,0-.008-.013-.024,0,0-.016-.029v0a5.783,5.783,0,0,0-4.076-2.93h0l-.072-.012h0l-.034-.005h0l-.035-.005h0l-.032,0H7.979l-.034,0h0l-.03,0H7.9l-.033,0c-.182-.022-.364-.036-.545-.041l-.165,0a5.8,5.8,0,0,0-5.731,5.036",
    transform: "translate(-1.376 -13.572)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3027",
    "data-name": "\\uC0AC\\uAC01\\uD615 3027",
    width: 11.891,
    height: 12.119,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 42"
  }, /*#__PURE__*/React.createElement("image", {
    width: 41,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAqCAYAAAAu9HJYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAiISURBVFhH7Zhbsts2EoZBUhJ1OXJlM6lUzUpSs4SZ93m2NzQLmDdvKPbRneJtvq9BynKcpJyUa2oeDLvdIAh0//13A4RcLP/1n3GxWKbNokw/LIv0w6pIL4uU3lToZZm2yGZRpXqpLNOqKtOiWqRlWSSWpLIoUoHYhnFM3TCmFumRe9elpu3Sve/Spe3TrVOGdG6H9LEr0qlN6eN9SB865/ap7do0IqnvkSFs0t6VZVmlBU62OF0DbF8l+iltBPcAuEhrZAPIzWqZXlZVyA7Z1swhMGW7KtNLXaW971jrmi3z167DjrImyBrZ4GMLGfWiSDv8VmWZKoMteJHUOXAbIGGLiTULdgBcl2OAldntBHBbrwBRPwEjiDWg1oBCv5lk71iN0xDAYnRbL+nXAXiNva3Bhu3sb4svzJCVIpVkqAAPiD8HKYuQkCCB6Ea0jMICssJYjeFVNTMD+CWG6b+sEiBGSgJB71boEOwAsmau8wVWawc2tWV/jSwBo08SEaVjJguBIpnJDNBW1kRC0GmDXgaDGpbZbHi9WgGKVGFReQFAgINN+282FbIIvVccA+ye98G4oAlKgJbLSqBBgn7xN/leowVeFlWAzWnPrbQ2RG9EERUGnLxQYHCFtm7AiaYclKn+tpH6HMCsNxhZW8swbsArJYLH7oINh83wMflZFWNswAoM1mSkOyEyGayifLlGTLmTooAxIEAN6USGBbrG8VpmALcB9S6YhT2Q7+caFLhgSXW9GCOwbCMHbulonzjYsLkWmY5vCEI8Kb5gskxjTFBiUQjHyxwpL8gQjhA147E7ediBeg9le5DvNzUbaRkA17yrQZFrOmeh0o5gsBlZUhybfM6gH0faLIIcYzCDDMqZzPqI0GffaUxHIVjK9WpaYZSdv6PwdgCVRY8ogxCE8xfFEEEK0A1iaS1gSduSoV9eRV8RlhJtzCo2EzYeJeC0+KMhnh1TXKDhkvEMGhB4XnmkALQGnH2ByFoOmI2gDrtIrNf25MdBGsOPNjozT3g0jvIxInluLpqCoOUFJQUeT2jXKwKO9EGV4rNA9JHn57lzKz6zSp8v1ANoVp/jm9/19OYP0MgiW4/yPV822hh6GJ2HabTv/QT2fLpaPnu3pk3NvU0dn7OByYpzNOc8NX8fkPU3M5ZdsoZ/BR5z82BeRCsFwJcynuWUadEbxyF6A6vpBsCBh4GHHt3yrb0Dym9uM4F0rGXM77afXrX+MuAMXtCSrJ8IVrtBgCMGoddPykZWXJy4GCgCyMA6Ol4W+PbjmAuA0iVkjEvClUvCBXDna5OO11s6hb6nc9PHu7ssE/29LxBsAmS+eLRDH/YNVtC4y/7p8zfgPqMsOxZ3DAhmvsG0MgUjrUBDdJblyq2lAcSVhxOAjrcWcIoAue0w5vtbO6YGowzBsAHmQLUbwQfg7BOTgGUeWoD2A+0EtOx5iIgF6UQM5SizQY0L/B5OM9ALVm+My5jMnRk8M3ZBXzHme4HGfCQHmZkLoR9k6BuS7mh9q6MeRalWBHnDAP4jCikPQIo1Z71h8MZLSg72RkCh2wJQ9gEZWlYFnOWKwcs98S5FaWRG1dwtlQmkzDI9Aldik1EKUQDiyxhT2TC5YfJV4V1DpDf6XlDdGE3bAi5fWgV5QU4APd0Q9PE2pAOiPjYABtiRcXUD2JtrWCtAL8CCnS+/+mZZALVv6t2csSncrVMrrT9rwokXU0l6bhrVAEavgNSBji4wKkvXqMUM7CDgexH6CPDjTWYFCzhLwbRr537HDuAEKoMhRZBjNi9oAfZxlCgTjbRyZOBKVE5yQTMUAdh6yynSMEBldKq3iwxFSgVMigF2FRj9GwxmxjNA114i0AzwRqov2DVr+hSggPOxFTl/pHluVfrb39+OfHc8r+ZbSLTpC2PLtfyp8PERhudjKVgBtLV3AYzBBPsUsixmoAQY7zPIX/iNc2bNibEzz93AGeNvHEosUj1tGtr7ciCygR9K7uqcbphxIamQiROi4wtodKjjU9Og7/mcFADa8UvLmJp3JygV3Nk12NBWMIgcwo+Zo1TwG+cz4CLDv0q1rUo//fw2fwTZ2XxxvAB48se3VFaJaD5wrZk433jOx8i0UwnCkyDqzd0La26OOPDpX+kbuPV+JPgDJ8WZvixaBh0kDaZaFgX5eXtfpR9/fusBGlc2/nRIxAG+fBhM32rAYTMkn6H5GJEFgSqNp4FgJ8ZyrcugjGU5yCDPH0h1HOwAlEWM4gT9Kc1ze1+kf/6bT7YXvgXXKm4z/A7xF+SOq9jOuyOvXtBbtD8vvEV7OY1rG+I1b26aNyBZlo+o1WkjvtL3y3Pj+Qh42e8B6KVkRD/S/CXId/mGZKFOlHcUr4tl4IhRa+cjUX8gRb9gyx/1R/TRomenH57kqDD+6jzmvzL3wLPiaeC7AwCjRATowT2n+LcBRivSP2AyetDjRZLfvvzwid/AijfsDeMy6RVfJv2x5E2bXxRpGfxlE177LJdg05LAtyXhgX1mMB8zbBKJEFgAVFjwOwBp7z6BnNv8+4HUB1h0ZZ8xU1wTzJzyuGlPy+Zmzfr9VXsG+on12ucZOAAqPn1Rg9CtZ8H+cZvS/dyMKujXqFFbN4i7FuOeaa+WAPL6SGFO/yuHuBvD8jhA4435fe9lmM3BekHm+ptSbJl9RfuSybnN6ecngToOeRkNDcMxhT4m5uYpkf9m9iKLM5hIr6AczPO+sv0Gk3PTkF4iNbnAR9iIeuKQbmfheRY3XWjGZW5E84DAHrv58SX5eoDRfh+kLQwKVBamOlLrmL6g41P2EMHkd6Cd1ihP4P4kQNsfg3xuGg9mcTinLgAL7EliXFDTvL8A6tft60E+t2CEf57ZeYhjCv1v1P4ayP9x+w7yW7XvIL9V+w7yW7Xi8T9Y/7ctpf8Camr6SDpHLzEAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11349",
    "data-name": "\\uD328\\uC2A4 11349",
    d: "M34.472,25.441a5.794,5.794,0,0,0,1.048-.191q.026-.093.048-.188a5.884,5.884,0,0,0,.12-.665c0-.01,0-.02,0-.031s0-.008,0-.012,0-.016,0-.023,0-.014,0-.021,0-.008,0-.011a5.813,5.813,0,0,0-.371-2.742L33.7,19.693Z",
    transform: "translate(-33.702 -19.693)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3029",
    "data-name": "\\uC0AC\\uAC01\\uD615 3029",
    width: 2.237,
    height: 5.971,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 9 21"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAVCAYAAACUhcTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADmSURBVDhPfZLRDcIwDEQdi2mYghVYg0HYgDXYASZgEgQ/CEpsc2eCREvoSU4geXp21Zbl9hjnR8j16TI8B7FaRVhmghxit17pohRhFZyw3ss42nYJ3gLOTED9ULzvSDLqWAo8EbBx6QQQgHR8ARNWHQe1GXKdAIziyQGJOMBsFxxgTKrh/wM6AkEtQe5fUWsX4TSwfqN3nA8AHW3SNLEwekM/zuM0cZ6cq9Mu3HDegM7jaYXB+TLTBKDXzqy+WxE07J3oaJY/0UgD6j+DT4UmzjFnwtSzAANoHmCKbPar9ruXS+zWpxesrqkyKqY4sAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11350",
    "data-name": "\\uD328\\uC2A4 11350",
    d: "M18.056,22.684a5.668,5.668,0,0,0,2.06,1.953l.909-5.067Z",
    transform: "translate(-18.056 -19.57)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3031",
    "data-name": "\\uC0AC\\uAC01\\uD615 3031",
    width: 3.179,
    height: 5.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-3",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 18"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAABvqT8MAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG0SURBVDhPPZNbltsgEEQLSfbkscKsLNvJ32wkP/mZc8YSEm9yG+zRUblBVBV0N3a9d/3999FTbQopK+SmK1UdscknyceuR+g6Y2VetYjn57e7ftxXfb/f9LYu2pZFt1XaXNNmEda2OPFOwRvE+23TjS/rCiwiWixC4h1j5xCZYMNmcYvc+Mii63ztg/h6HHNbHILI2Uutaq0PVNZITY0fiyZvHTmTL0EuVRlRNUHTiEaeYhsDuENwXFH7lahI1UWVrGK5iujAdM/DqE3BJJdRuogg5K5YDGLnrmRgq1LLFPjUdGJ1YXsyNpGRE+CkY0dzz8QhMGcjGqxxITudmdyeziZI5Fdegj3QVTpqnd2TG10OQ0yH2TnkMgpjopl0XiAZ0a4AwD2kPo4Yix2vDHJgPgXsYK7kjqO5Mrd8cD5TQkxkHF5HMsEeqh5X0U62PiaIGYME8hSS2wFmDpAOXHYWD8gGHyM5IYbsn2QTDYGPQT5AMGdgrkay3niO5snjomJHe96lPWYwyQfjB2U+IH9SoZ18dqr1oCcfxPEH+vX7/Y/dk3mP6ChIIHMlTlw9yV7Wl9r1HyxjzGKVuGb0AAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11351",
    "data-name": "\\uD328\\uC2A4 11351",
    d: "M25.466,25.2a5.741,5.741,0,0,0,2.684.662c.153,0,.306-.006.458-.018l-1.539-5.58Z",
    transform: "translate(-25.466 -20.268)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3033",
    "data-name": "\\uC0AC\\uAC01\\uD615 3033",
    width: 3.356,
    height: 5.793,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-4",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 21"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 21,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHASURBVDhPlZNLTsQwDIadsOTIrLgI4iJIXIQjIGY67bR58/1uK1iwIZKT1P0fjtOGMYb9Z4SXt4+xpGFL7nZL2WZizdWuiq3ZVxl2a8E+UyfXn2OMwRQhmD0wRalof6yDOIeeY2BWTqsyvuzvGcNFnOxPEvzjDD+ZX9QjGTsbxWDqZM8XndC+MTUl3GJYbACVdGLv5IZVFyEnIJN38hCKFXptwzLg0ggJtMYqUrCEtPZZnNEtFoEJgVpvViFWgBViAXC6ZyaZRIEzNrlVd9DenchvHQcqkKvKGgjGO36pVkulsULgZSJUwg42iJTtTpSUa7Gt1MOl28aJRVxxWCFskFc5oK5Oxg3lQv2ZRFJJUvdDclhUte/kPOSw5sJ3VG3mzYz/gsOM8sw3dGe/EoVGdM5IVywulKNz3FUGMfGhXQBtlDSrezgLPCBhsx96AahVYLkkxGZC3XKCwJTjhCk3u6F4qcEmL8Ns4vkOWMq6n3GU4zc9sb8WQIBnrV43l0f3KmA7wXKgCVE/yBdNv7JeAG7cyQnelSF5SW6gQ/O3oaqydA9VhN9l0E4pnyM8Pr2/NxT2bhwdEcDBexk/w16/ARhLBcndY9RJAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11352",
    "data-name": "\\uD328\\uC2A4 11352",
    d: "M15.013,16.1l2.863-1.552L15.218,14.3a5.85,5.85,0,0,0-.2,1.794",
    transform: "translate(-15.009 -14.301)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3035",
    "data-name": "\\uC0AC\\uAC01\\uD615 3035",
    width: 3.12,
    height: 2.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-5",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 7"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC8SURBVChTLZBJEsMgDASHVcJg//+Sp+SQj+QdWRyUEYmpLhClHtkOZobL9W4pBfjyx+8mOSfw+QDP0/B4T7zmvEVvGBIwKnCo4RBjDfQaFkKUtBrRcsISejXslDqlzmY/uzR470HNhfJjCXvLJOHg7uwaMTQtPGS4wBCftgTJHFdITQst3FkrEyUH1GTgG6HEvzAkMdWTC7+DcErn3SYZGzuVshQGkyV46sZqaEUnjefGKZV/LnN6yZ7uAF/jDiNrtQgl/wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11353",
    "data-name": "\\uD328\\uC2A4 11353",
    d: "M15.125,18.929a5.8,5.8,0,0,0,.721,2.216l2.463-3.413Z",
    transform: "translate(-15.125 -17.732)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3037",
    "data-name": "\\uC0AC\\uAC01\\uD615 3037",
    width: 3.414,
    height: 3.547,
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-6",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 13 13"
  }, /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFDSURBVChTlZJdcsMgDIQXG2ycSe9/nr71CD1AT9A45h+ykptMp2/Fs5Zg9hNYxowx8N+h0Mfn17CTwWzOxdoHSu0obSCVjnsBjmJwpI5Yxvskpusy483bl67rjMtqsTF6iim8HVicgWNlhS7e0UxdvOrqF2ws5O2EdZ6wWANO4ejm9IRWKxVpXJ3KixZL8wTLyo5HZ6p6QY6ZI7gRXBdHI800Tub8zpkvppyzCXwU0g5Sf/v4XGFfdDwbrZB0K9eGEBNiyuxcQ+sdnetsIIZEShh5KxRzUYVUcMR85rmy0Nn2QqAPwxyEf3Y6csMtFHwfiTFjj4RTk3+CTFeuEkH4F3RPlcaq8ca4Ewh0BJYOdHNTFoDCsrNCIXf+8abVxaRzKlKJNyEQYj3wUxVUaOf12COPSEiiSArI9bnnwfy8TqJQOx75YvJdq5R9HwAAAABJRU5ErkJggg=="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3162",
    "data-name": "\\uADF8\\uB8F9 3162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3137",
    "data-name": "\\uADF8\\uB8F9 3137",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3136",
    "data-name": "\\uADF8\\uB8F9 3136",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11338",
    "data-name": "\\uD328\\uC2A4 11338",
    d: "M30.58.009a5.738,5.738,0,0,0-1.257.2l.548,1.983Z",
    transform: "translate(-20.662 -0.006)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11339",
    "data-name": "\\uD328\\uC2A4 11339",
    d: "M35.969.289A5.772,5.772,0,0,0,34.389,0L33.96,2.4Z",
    transform: "translate(-23.929 0)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11340",
    "data-name": "\\uD328\\uC2A4 11340",
    d: "M25.067,1.3a5.7,5.7,0,0,0-1.008.513l1.272,1.458Z",
    transform: "translate(-16.953 -0.918)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11341",
    "data-name": "\\uD328\\uC2A4 11341",
    d: "M42.083,8.557a5.779,5.779,0,0,0-1.306-2.289L37.35,8.125Z",
    transform: "translate(-26.318 -4.409)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11342",
    "data-name": "\\uD328\\uC2A4 11342",
    d: "M42.046,17.73a5.865,5.865,0,0,0,.041-3.082l-4.8.222Z",
    transform: "translate(-26.273 -10.303)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11343",
    "data-name": "\\uD328\\uC2A4 11343",
    d: "M20.449,4.179a6.2,6.2,0,0,0-.51.451c-.117.118-.224.241-.329.367l1.913.818Z",
    transform: "translate(-13.818 -2.939)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11344",
    "data-name": "\\uD328\\uC2A4 11344",
    d: "M39.7,2.685a5.779,5.779,0,0,0-1.743-1.158l-1.8,2.488Z",
    transform: "translate(-25.483 -1.074)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11345",
    "data-name": "\\uD328\\uC2A4 11345",
    d: "M35.987,17.956l3.259,4.967c.144-.12.285-.246.42-.381a5.8,5.8,0,0,0,1.437-2.4Z",
    transform: "translate(-25.357 -12.63)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11346",
    "data-name": "\\uD328\\uC2A4 11346",
    d: "M16.907,8.459A5.744,5.744,0,0,0,16.26,9.7l2.517-.117Z",
    transform: "translate(-11.457 -5.95)",
    fill: "#7da9d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11347",
    "data-name": "\\uD328\\uC2A4 11347",
    d: "M39.568,28.82a5.811,5.811,0,0,0-.36-2.841l2.278,2.611A5.736,5.736,0,0,1,39.4,29.672a5.755,5.755,0,0,0,.168-.852",
    transform: "translate(-27.627 -18.273)",
    fill: "#7da9d7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3141",
    "data-name": "\\uADF8\\uB8F9 3141",
    transform: "translate(0.406 4.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3140",
    "data-name": "\\uADF8\\uB8F9 3140",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3139",
    "data-name": "\\uADF8\\uB8F9 3139",
    transform: "translate(-0.406 -0.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3138",
    "data-name": "\\uADF8\\uB8F9 3138",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3026",
    "data-name": "\\uC0AC\\uAC01\\uD615 3026",
    width: 11.891,
    height: 12.068,
    fill: "url(#pattern)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3145",
    "data-name": "\\uADF8\\uB8F9 3145",
    transform: "translate(9.955 5.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3144",
    "data-name": "\\uADF8\\uB8F9 3144",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3143",
    "data-name": "\\uADF8\\uB8F9 3143",
    transform: "translate(-0.067 -0.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3142",
    "data-name": "\\uADF8\\uB8F9 3142",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3028",
    "data-name": "\\uC0AC\\uAC01\\uD615 3028",
    width: 2.237,
    height: 5.946,
    fill: "url(#pattern-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3149",
    "data-name": "\\uADF8\\uB8F9 3149",
    transform: "translate(5.333 5.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3148",
    "data-name": "\\uADF8\\uB8F9 3148",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3147",
    "data-name": "\\uADF8\\uB8F9 3147",
    transform: "translate(-0.096 -0.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3146",
    "data-name": "\\uADF8\\uB8F9 3146",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3030",
    "data-name": "\\uC0AC\\uAC01\\uD615 3030",
    width: 3.179,
    height: 5.18,
    fill: "url(#pattern-3)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3153",
    "data-name": "\\uADF8\\uB8F9 3153",
    transform: "translate(7.522 6.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3152",
    "data-name": "\\uADF8\\uB8F9 3152",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3151",
    "data-name": "\\uADF8\\uB8F9 3151",
    transform: "translate(-0.106 -0.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3150",
    "data-name": "\\uADF8\\uB8F9 3150",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3032",
    "data-name": "\\uC0AC\\uAC01\\uD615 3032",
    width: 3.356,
    height: 5.769,
    fill: "url(#pattern-4)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3157",
    "data-name": "\\uADF8\\uB8F9 3157",
    transform: "translate(4.433 4.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3156",
    "data-name": "\\uADF8\\uB8F9 3156",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3155",
    "data-name": "\\uADF8\\uB8F9 3155",
    transform: "translate(-0.137 -0.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3154",
    "data-name": "\\uADF8\\uB8F9 3154",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3034",
    "data-name": "\\uC0AC\\uAC01\\uD615 3034",
    width: 3.12,
    height: 2.002,
    fill: "url(#pattern-5)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3161",
    "data-name": "\\uADF8\\uB8F9 3161",
    transform: "translate(4.468 5.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3160",
    "data-name": "\\uADF8\\uB8F9 3160",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3159",
    "data-name": "\\uADF8\\uB8F9 3159",
    transform: "translate(-0.112 -0.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3158",
    "data-name": "\\uADF8\\uB8F9 3158",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3036",
    "data-name": "\\uC0AC\\uAC01\\uD615 3036",
    width: 3.414,
    height: 3.532,
    fill: "url(#pattern-6)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo2);
export default __webpack_public_path__ + "static/media/footer-logo2.56cf7ac89c36b137d1b8139e027485fc.svg";
export { ForwardRef as ReactComponent };